import { ActionPattern } from "redux-saga/effects";
import { SetValueAction } from "../Actions";

export const setValueActionCreator = <TValue, TAction extends string = any>(actionType: TAction) => {
    const actionCreator = (value: TValue) => ({
        type: actionType,
        value,
    });

    actionCreator.toString = () => actionType;

    return actionCreator;
};

export function createValueReducer<TValue>(actionType: ActionPattern, initValue: TValue = null) {
    return (state: TValue = initValue, action: SetValueAction<TValue, string>) => {
        return action.type === actionType.toString() ? action.value : state;
    };
}
